export interface BaseAction {
  type: string;
  payload?: any;
};

export const actionTypes = {
  RESOURCES: {
    SET_LANGUAGE: 'SET_LANGUAGE',
    SET_AVAIL_OPTIONS: 'SET_AVAIL_OPTIONS',
    FETCH_RESOURCES: 'FETCH_RESOURCES',
    ADD_LOCALE: 'ADD_LOCALE'
  },
  MYFAVORITE: {
    UNLOGIN_ADD_FAVORITE_ITEM: 'UNLOGIN_ADD_FAVORITE_ITEM',
    ADD_FAVORITE_ITEM: 'ADD_FAVORITE_ITEM',
    REMOVE_FAVORITE_ITEM: 'REMOVE_FAVORITE_ITEM',
    FETCH_MY_FAVORITE: 'FETCH_MY_FAVORITE',
    FETCH_MY_FAVORITE_COMPLETE: 'FETCH_MY_FAVORITE_COMPLETE'
  },
  MEMBER: {
    LOG_OUT: 'LOG_OUT'
  },
  MODAL: {
    SET_GAME_QUALIFY_MODAL_VISIBLE: 'SET_GAME_QUALIFY_MODAL_VISIBLE',
    SET_CAPTCHA_ERROR_MODAL_VISIBLE: 'SET_CAPTCHA_ERROR_MODAL_VISIBLE',
    SET_CAPTCHA_SEND_MODAL_VISIBLE: 'SET_CAPTCHA_SEND_MODAL_VISIBLE',
    SET_CAPTCHA_RETURN_MODAL_VISIBLE: 'SET_CAPTCHA_RETURN_MODAL_VISIBLE',
    SET_GUARDIANSHIP_STATEMENT_MODAL_VISIBLE: 'SET_GUARDIANSHIP_STATEMENT_MODAL_VISIBLE',
    SET_FILL_PASSPORT_MODAL_VISIBLE: 'SET_FILL_PASSPORT_MODAL_VISIBLE',
    SET_INFO_MODAL_VISIBLE: 'SET_INFO_MODAL_VISIBLE',
    SET_RULE_VALID_ERROR_MODAL_VISIBLE: 'SET_RULE_VALID_ERROR_MODAL_VISIBLE',
    SET_FILL_EXAMPLE_MODAL_VISIBLE: 'SET_FILL_EXAMPLE_MODAL_VISIBLE',
    SET_SELECT_VEHICLE_BRANDS_MODAL_VISIBLE: 'SET_SELECT_VEHICLE_BRANDS_MODAL_VISIBLE',
    SET_SELECT_VEHICLE_MODELS_MODAL_VISIBLE: 'SET_SELECT_VEHICLE_MODELS_MODAL_VISIBLE',
    SET_SELECT_INSURANCE_TYPE_MODAL_VISIBLE: 'SET_SELECT_INSURANCE_TYPE_MODAL_VISIBLE',
    SET_MEMBER_INFO_ERROR_MODAL_VISIBLE: 'SET_MEMBER_INFO_ERROR_MODAL_VISIBLE',
    SET_LOGIN_MODAL_VISIBLE: 'SET_LOGIN_MODAL_VISIBLE',
    SET_LOGIN_MODAL_LOGIN_DONE: 'SET_LOGIN_MODAL_LOGIN_DONE',
    SET_VET_HOSPITAL_MODAL_VISIBLE: 'SET_VET_HOSPITAL_MODAL_VISIBLE',
    SET_INSURE_HELPER_MODAL_VISIBLE: 'SET_INSURE_HELPER_MODAL_VISIBLE',
    SET_ABROAD_MODAL_VISIBLE: 'SET_ABROAD_MODAL_VISIBLE',
    SET_EXPLAIN_MODAL_VISIBLE: 'SET_EXPLAIN_MODAL_VISIBLE',
    SET_PRODUCT_EXPLAIN_MODAL_VISIBLE: 'SET_PRODUCT_EXPLAIN_MODAL_VISIBLE',
    SET_CONFIRM_MODAL_VISIBLE: 'SET_CONFIRM_MODAL_VISIBLE'
  },
  LOADING: {
    SET_LOADING_VISIBLE: 'SET_LOADING_VISIBLE'
  }
};
